import { useGetDashboardUserSettings } from '../apiCalls/dashboardusersettings';
import useGetBootstrap from '../apiCalls/bootstrap';

// build this component to import data that is global in the app (data that is the same and used regardless of what user you are or account you are in)
export default function AppDataLoader() {
  useGetBootstrap();
  useGetDashboardUserSettings();
}
